import { render, staticRenderFns } from "./TierForm.template.vue?vue&type=template&id=3bc42864&scoped=true&"
var script = {}
import style0 from "./TierForm.template.vue?vue&type=style&index=0&id=3bc42864&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc42864",
  null
  
)

export default component.exports